import React, { useState } from 'react'
import { Button, ButtonGroup, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import InsertChartIcon from '@mui/icons-material/InsertChart'
import GoogleIcon from '../../icon/GoogleIcon'
import {
  DOWNLOAD_ACTION_DEFAULT_CSV_LABEL,
  DOWNLOAD_ACTION_DEFAULT_LABEL,
  DOWNLOAD_ACTION_DEFAULT_PDF_LABEL
} from '../../constants/downloadActionConstants'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_HOVER,
  UI_COLOR_WHITE
} from '../../constants/uiColors'

export default function DownloadCsvPdfSplitButton({
  label = DOWNLOAD_ACTION_DEFAULT_LABEL,
  csvLabel = DOWNLOAD_ACTION_DEFAULT_CSV_LABEL,
  pdfLabel = DOWNLOAD_ACTION_DEFAULT_PDF_LABEL,
  onExportCsv,
  onExportPdf,
  disabled = false,
  color = UI_COLOR_ACCENT_ORANGE,
  hoverColor = UI_COLOR_ACCENT_ORANGE_HOVER,
  sx
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <ButtonGroup
        disableElevation
        sx={sx}
        style={{
          '--download-action-bg': color,
          '--download-action-hover-bg': hoverColor
        }}
      >
        <Button
          className="download-doble-reports"
          disabled={disabled}
          onClick={onExportCsv}
          startIcon={<GoogleIcon name="download_2" size={16} filled color={UI_COLOR_WHITE} />}
        >
          {label}
        </Button>

        <Button
          className="download-doble-reports-arrow"
          size="small"
          disabled={disabled}
          onClick={(event) => setAnchorEl(event.currentTarget)}
          sx={{
            minWidth: 36,
            px: 0
          }}
        >
          <KeyboardArrowDownIcon />
        </Button>
      </ButtonGroup>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              border: '1px solid #D8E0E8',
              borderRadius: '12px',
              boxShadow: '0 12px 32px rgba(39, 88, 141, 0.16)',
              '& .MuiList-root': {
                py: 0.5
              }
            }
          }
        }}
      >
        <MenuItem
          disabled={disabled}
          onClick={() => {
            handleClose()
            onExportCsv()
          }}
        >
          <ListItemIcon>
            <InsertChartIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{csvLabel}</ListItemText>
        </MenuItem>

        <MenuItem
          disabled={disabled}
          onClick={() => {
            handleClose()
            onExportPdf()
          }}
        >
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{pdfLabel}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}
